<div class="item flex flex-col gap-4">
  <label
    [for]="identifier()"
    class="flex w-full items-center justify-between rounded-lg bg-transparent px-4 py-2 hover:bg-gray-700 focus:outline-none">
    <input
      #input
      type="checkbox"
      [id]="identifier()"
      [checked]="isOpen()"
      (change)="toggle()" />
    <div class="flex w-full items-center justify-between gap-2">
      <ng-content select="title"></ng-content>
      <icon
        name="chevron-up-icon"
        [class.rotate-180]="isChecked()"
        class="text-gray-soft transition-transform" />
    </div>
  </label>

  <div>
    <ng-content select="content"></ng-content>
  </div>
</div>
